module.exports = __webpack_public_path__ + "img/Titel.5187afb5.png";